import { styled } from 'lib/ui';

export const RestaurantItemTitle = styled.div.attrs({
  className: 'RestaurantItemTitle',
})`
  cursor: pointer;
`;
